<template>
    <v-container fluid ma-3 pa-3>
        <v-layout row wrap justify-center>
            <v-flex>
                <span class="style_title">Startup Registration</span>
                <br>
                <br>
                <div>
                    <span class="style_description" style="white-space: pre-line">Startups can register to Discovery by accessing "Related-startup services" -> "Registration".
First step, the startup must read and accept <strong>NTT DATA's Information Policy</strong>. Only after downloading the document and ticking the checkbox, it will be possible to accept the policy and proceed with the registration.
The registration form is to be compiled ONLY by startups that have not yet received their identification token by email, useful for registering to the challenges.
</span>
                    <br>
                    <span class="style_paragraph" style="white-space: pre-line">Suggestions for form fields</span>
                    <br>

                    <span class="style_description" style="white-space: pre-line">Mandatory fields are:
                        <ul>
                            <li>"Startup name": startup identification name or company name</li>
                            <li>"Email addresses": one or more email contacts. In the case of multiple contacts, you must separate each of them with the symbols , or ; or /.</li>
                        </ul>
Other tips:
                        <ul>
                            <li>Except for the “Startup name” and “English/Italian idea description” fields, no special characters are allowed</li>
                            <li>Fields “Website”, ”Contact Links”, "Logo","Url Video" and “Crunchbase link” must contain URLs</li>
                            <li>Field “Number Employees” mustn’t contain a negative number</li>
                        </ul>

The registration submission is protected for security reasons by <strong>Google Captcha</strong>. In order to continue with the registration, you must therefore tick the box "I'm not a robot" and, if requested, solve the proposed challenge.

To confirm your registration, press the green "Submit" button. If your submission is successful, you will receive a "Registration successful" notification on your screen and an email to the address indicated in the "Email addresses" field.

The registration will have to be evaluated by Discovery admins. As soon as possible, the startup will receive a second email with the result of the evaluation. In case of success, the email will also contain the identification token, which will be useful for future participation to the challenges and for the modification your personal data.
</span>
                </div>
                <br>


            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>

    export default {
        name: "StartupRegistrationHelp",
        components: {},
        data() {
            return {

            }
        },

        methods: {

        }
    }
</script>

<style scoped>
    .style_description{
        font-size: 18px;
    }

    .style_paragraph{
        font-size: 22px;
        font-weight: bold;
    }

    .style_title{
        font-size: 34px;
        font-weight: bold;
    }

</style>